'use client';
import { FormEvent, ChangeEvent, useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import Image from 'next/image';

import SearchIcon from 'public/img/icon/search-51x53.svg';

import './PLPSearchBar.style.scss';

type PLPSearchBarProps = {
  className?: string;
  onSearch: (query: string) => void;
  placeholder?: string;
};

function PLPSearchBar(props: PLPSearchBarProps) {
  const { className = '', onSearch, placeholder = 'Search' } = props;
  const [value, setValue] = useState('');
  const [expanded, setExpanded] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expanded]);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearch(value);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleToggle = () => {
    if (!expanded) {
      setExpanded(true);
    }
  };

  const handleClear = () => {
    setValue('');
    onSearch('');
    setExpanded(false);
  };

  const handleBlur = () => {
    if (!value) {
      setExpanded(false);
    }
  };

  return (
    <form
      className={cn('PLPSearchBar', className, { expanded })}
      onSubmit={handleSubmit}
    >
      <input
        ref={inputRef}
        className='PLPSearchBar-input'
        type='text'
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
      />
      {value ? (
        <button
          className='PLPSearchBar-clear'
          type='button'
          onClick={handleClear}
          aria-label='Clear search'
        >
          &times;
        </button>
      ) : (
        <button
          className='PLPSearchBar-toggle'
          type='button'
          aria-label='Open search'
          onClick={handleToggle}
        >
          <Image
            src={SearchIcon}
            alt=''
            width={16}
            height={16}
            className='PLPSearchBar-icon'
          />
        </button>
      )}
    </form>
  );
}

export default PLPSearchBar;
